import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from './LanguageContext';
import translations from '../translations.json';
import './Reviews.css';

const Reviews: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language]['reviews'];

  return (
    <section className="reviews vh-100 d-flex flex-column justify-content-center" id="reviews">
      <Container>
        <Row>
          <Col className='text-center'>
            <h1 dangerouslySetInnerHTML={{ __html: t.title }} />
          </Col>
        </Row>
        <Row className="justify-content-center mt-5">
          <Col>
            {t.testimonials.map((testimonial, index) => (
              <div className="testimonial mb-4" key={index}>
                <p className="testimonial-text text-left fs-6">{testimonial.text}</p>
                <p className="testimonial-author">{testimonial.author}</p>
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Reviews;
